var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ListadoProductos from "../services/listadoProductos";
var initialState = {
    cargandoMasPaginado: false,
    posicionEnLista: 0,
    datosListadoDeProductos: null,
};
//slice
var listadoProductosSlice = createSlice({
    name: "listadoColeccionSlice",
    initialState: initialState,
    reducers: {
        resetListadoProductos: function (state) { return initialState; },
        aumentarPosicionEnLista: function (state, action) {
            state.posicionEnLista = action.payload;
        },
        cambiarEstadoCargandoMas: function (state, action) {
            state.cargandoMasPaginado = action.payload;
        },
        quitarProductoDeLista: function (state, action) {
            state.datosListadoDeProductos.listaProductos =
                state.datosListadoDeProductos.listaProductos.filter(function (item) { return item.id != action.payload; });
        },
        quitarTodosProductoDeLista: function (state, action) {
            state.datosListadoDeProductos.listaProductos = [];
        },
        dragProductoDeLista: function (state, action) {
            state.datosListadoDeProductos.listaProductos = action.payload;
        },
    },
    extraReducers: function (builder) {
        builder.addCase(getListadoProductos.fulfilled, function (state, action) {
            var data;
            if (state.posicionEnLista !== 0) {
                //Si es paginado hacemos push de productos pero escribimos todo el slice
                data = action.payload;
                //Creamos variable desde state para luego a esa variable hacerle push ya que state no se le puede hacer push.
                var productosActuales = state.datosListadoDeProductos.listaProductos;
                //Se modifica de variable temporal listaProductos
                data.listaProductos = productosActuales.concat(data.listaProductos);
            }
            else {
                //Si es 0 posicion, guardamos todo el slice.
                data = action.payload;
            }
            state.cargandoMasPaginado = false;
            state.datosListadoDeProductos = data;
        });
        builder.addCase(reorderListadoProductos.fulfilled, function (state, action) { });
    },
});
//get datos de tendencias
export var getListadoProductos = createAsyncThunk("getListadoProductos/index", function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, err_1, error_listado_productos;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, ListadoProductos.getListadoProductos(data)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response];
            case 2:
                err_1 = _a.sent();
                error_listado_productos = "ERROR_GET_LISTADO_PRODUCTOS";
                console.error(error_listado_productos, err_1);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); });
export var reorderListadoProductos = createAsyncThunk("reorderListadoProductos/index", function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, err_2, error_listado_productos;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, ListadoProductos.reorderListadoProductos(data)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response];
            case 2:
                err_2 = _a.sent();
                error_listado_productos = "ERROR_GET_REORDER_LISTADO_PRODUCTOS";
                console.error(error_listado_productos, err_2);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); });
export var aumentarPosicionEnLista = (_a = listadoProductosSlice.actions, _a.aumentarPosicionEnLista), cambiarEstadoCargandoMas = _a.cambiarEstadoCargandoMas, quitarProductoDeLista = _a.quitarProductoDeLista, quitarTodosProductoDeLista = _a.quitarTodosProductoDeLista, dragProductoDeLista = _a.dragProductoDeLista;
export default listadoProductosSlice;
